import React from 'react';
import useReportedHoursService from './useReportedHoursService';
import { Show } from 'framework/show';
import ReportedHoursAnalysisContent from './ReportedHoursAnalysisContent';

const ReportedHoursAnalysis = () => {
  const { getAssignmentsLastTreeMothDataMethod } = useReportedHoursService();

  return (
    <Show getDataMethod={getAssignmentsLastTreeMothDataMethod}>
      <ReportedHoursAnalysisContent />
    </Show>
  );
};

export default ReportedHoursAnalysis;
